var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 6.45312H7.54688V0.546875C7.54688 0.244836 7.30204 0 7 0C6.69796 0 6.45312 0.244836 6.45312 0.546875V6.45312H0.546875C0.244836 6.45312 0 6.69796 0 7C0 7.30204 0.244836 7.54688 0.546875 7.54688H6.45312V13.4531C6.45312 13.7552 6.69796 14 7 14C7.30204 14 7.54688 13.7552 7.54688 13.4531V7.54688H13.4531C13.7552 7.54688 14 7.30204 14 7C14 6.69796 13.7552 6.45312 13.4531 6.45312Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.798ec22595e89a6116e5a0b2619a8bba.svg";
export { ForwardRef as ReactComponent };